module.exports = __webpack_public_path__ + "img/TIE1.7884a3a2.png";